import { useWSMutation, WSMutationConfig } from "@ws-react-query";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { REQUIREMENTS_DEPENDENCIES } from "../../../modules/Requirements/dependencies";
import { renewRequirement } from "../../../services/requirements/renewRequirement";

export const useMutationRenewRequirement = (
  config?: WSMutationConfig<IRequirementResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSMutation(
    (requirementId: string) =>
      renewRequirement(requirementId, xWingspanPayerId),
    {
      ...config,
      dependencies: [...REQUIREMENTS_DEPENDENCIES]
    }
  );
};
